import { render, staticRenderFns } from "./watchSection.vue?vue&type=template&id=f8273ce6&scoped=true&"
import script from "./watchSection.vue?vue&type=script&lang=js&"
export * from "./watchSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8273ce6",
  null
  
)

export default component.exports